import {UrlCheckoutParamsType} from '@daedalus/core/src/utils/url/types/UrlParams'
import getUrlParams from '@daedalus/core/src/utils/url/urlParamsParser'

export const urlParams = () => getUrlParams() as UrlCheckoutParamsType
